import { createTheme } from "@mui/material";

declare module "@mui/material/IconButton" {
	export interface IconButtonPropsColorOverrides {
		neutral: true;
	}
}

declare module "@mui/material/styles" {
	interface Palette {
		neutral: Palette["primary"];
	}
	interface PaletteOptions {
		neutral: PaletteOptions["primary"];
	}
}

export const grayscaleText = "#2a2e33";
export const whiteText = "#ffffff";
export const grayMed = "#afafb8";
export const grayscaleBg = "#f0f2f7";
export const globalBg = "#e3e3eb";
export const grayscaleGrayDark = "#434951";

export const colorGrayLight = "#E3E3EB";
export const colorGrayDark = "#7F7F87";
export const colorDark = "#404044";

// article accuracy grading colors
export const colorLime = "#4ebc78";
export const colorMelon = "#80BA75";
export const colorPotato = "#B1B772";
export const colorAvocado = "#B5BB9C";
export const colorDragonFruit = "#B9BEC6";

export const colorMango = "#ff9f1c";
export const colorGuava = "#eb5160";
export const colorHot = "#f9b99f";
export const colorCold = "#b3dbfa";

export const customTheme = createTheme({
	components: {
		MuiAlert: {
			styleOverrides: {
				standardInfo: {
					backgroundColor: grayscaleBg,
					color: grayscaleText,
					borderRadius: 0,
					borderTop: "1px solid",
					borderColor: globalBg,
					boxShadow: "none",
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					borderTopLeftRadius: 0,
					borderTopRightRadius: 0,
					boxShadow: "0 5px 5px 0 rgba(0, 0, 0, 0.25)",
					backgroundColor: "#fff",
				},
			},
		},
	},
	typography: {
		fontFamily: '"DM Sans", "sans-serif"',
		h3: {
			lineHeight: "125%",
			fontSize: 24,
			fontWeight: "Medium",
			letterSpacing: "-1%",
		},

		h5: {
			lineHeight: 1,
			fontSize: 24,
			fontWeight: "bold",
			color: whiteText,
		},
		h4: {
			lineHeight: 1,
			fontSize: 36,
			fontWeight: "bold",
			color: colorDark,
		},
		subtitle2: {
			lineHeight: 1,
			fontSize: 24,
			fontWeight: "bold",
			color: colorDark,
		},
		body1: {
			lineHeight: "100%",
			fontSize: 16,
			letterSpacing: "-1%",
		},
		body2: {
			lineHeight: "150%",
			fontSize: 14,
			letterSpacing: "-1%",
			// lineHeight: 1,
			// fontSize: 18,
			// color: whiteText,
		},
		caption: {
			lineHeight: 1,
			fontWeight: "normal",
			fontSize: 12,
			color: colorGrayDark,
		},
	},
	palette: {
		background: {
			default: "#e7ebf0",
		},
		text: {
			primary: grayscaleText,
			secondary: whiteText,
		},
		primary: {
			main: grayscaleText,
		},
		secondary: {
			main: grayscaleBg,
		},
		success: {
			main: "#6CBD73",
		},
		warning: {
			main: "#D54753",
		},
		neutral: {
			main: whiteText,
		},
	},
});
